import React from "react";
import classNames from "classnames";

import "./modal.css";
import Button from "../button/button-component";

const Modal = ({ close, show, children, title, save, async, loading }) => {
  return (
    <div
      className={classNames({
        modal__container: true,
        modal__container_show: show
      })}
    >
      <div className="modal__container__content">
        <div className="modal__container__content__header">
          <div className="modal__container__content__header__row">
            <div className="modal__container__content__header__row__title">
              {title || "Modal title should be here"}
            </div>
            <div className="modal__container__content__header__row__void" />
            <Button
              name="Save"
              primaryBtn
              async={async}
              loading={loading}
              width="20%"
              height="100%"
              style={{
                marginRight: '10px'
              }}
              handler={() => {
                if (async) {
                  save();
                } else {
                  save();
                  close();
                }
              }}
            />
            <Button
              name="Cancel"
              width="20%"
              height="100%"
              handler={close}
            />
            {/*<button*/}
              {/*className={classNames(*/}
                {/*"primary_btn",*/}
                {/*"modal__container__content__footer__save"*/}
              {/*)}*/}
              {/*onClick={() => {*/}
                {/*if (async) {*/}
                  {/*save();*/}
                {/*} else {*/}
                  {/*save();*/}
                  {/*close();*/}
                {/*}*/}
              {/*}}*/}
              {/*style={{width: '20%', flex: '1'}}*/}
            {/*>*/}
              {/*Save*/}
              {/*<i*/}
                {/*className="fas fa-spinner fa-spin"*/}
                {/*style={{*/}
                  {/*marginLeft: "10px",*/}
                  {/*visibility: loading ? "visible" : "hidden",*/}
                  {/*position: "absolute"*/}
                {/*}}*/}
              {/*/>*/}
            {/*</button>*/}
            {/*<button*/}
              {/*className="modal__container__content__footer__cancel"*/}
              {/*onClick={close}*/}
            {/*>*/}
              {/*Cancel*/}
            {/*</button>*/}

          </div>
        </div>
        <div className="modal__container__content__body">
          {children || "Modal content should be here"}
        </div>
      </div>
    </div>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal/modal-component.js